import { JuteManager } from './jute-manager';
import './index.scss';

const Jute = new JuteManager();

(window as any).Jute = Jute;

if (typeof (window as any).JUTE_OPTIONS !== 'undefined') {
    Jute.init((window as any).JUTE_OPTIONS)
}

export { Jute };
